var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModeFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#888888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m479.43-94-71-63.87q-103.26-92.69-170.67-160.39-67.41-67.7-106.7-121.61Q91.78-493.78 76-539.48 60.22-585.17 60.22-634q0-102.45 68.5-171.12 68.5-68.66 170.71-68.66 51.4 0 97.85 19.74 46.46 19.73 82.15 56.91 35.7-37.18 82.15-56.91 46.46-19.74 97.85-19.74 102.7 0 171.53 68.66 68.82 68.67 68.82 171.12 0 48.26-15.5 93.96-15.5 45.69-55.06 99.32-39.57 53.63-107.26 121.61-67.7 67.98-171.52 161.24L479.43-94Zm0-142.48q94.87-86 156.03-146.09 61.15-60.08 96.3-104.73 35.15-44.66 48.59-78.83 13.43-34.17 13.43-67.86 0-57.75-38.31-95.77-38.3-38.02-95.76-38.02-45.01 0-83.88 26.5t-53.87 67.5h-84.48q-14.73-41-54.02-67.5-39.29-26.5-83.87-26.5-56.92 0-94.86 38.02-37.95 38.02-37.95 95.76 0 34.3 13.69 69.08 13.68 34.79 48.87 79.38 35.18 44.58 95.77 104.39 60.59 59.8 154.32 144.67Zm1.14-265.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeFavorite);
export default __webpack_public_path__ + "static/media/modeFavorite.e45e8cee6226898a083ffb59c4c598ca.svg";
export { ForwardRef as ReactComponent };